import { ImageMarkerIcon } from './ImageMarkerIcon';

/**
 * author: Colton Wiscombe
 * id 39EFA2D6-FC32-491C-8ABE-384AA47B94D3
 * name image-marker
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-marker.svg
 * tags
 * - Navigation 
 */
export const ImageLocationIcon = ImageMarkerIcon;
export default ImageLocationIcon